import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ColTwo from "./components/ColTwo";
import ColThree from "./components/ColThree";
import "./footer.css";
import Copyright from "./components/Copyright";
import { useExternalMedia } from "../../hooks/useExternalMedia";
import InternalLinks from "./components/InternalLinks";
import { Link } from "react-router-dom";
import { HOME } from "../../routes/paths.routes";





export default function Footer() {


  const { logo } = useExternalMedia()
  return (
    <>
      <footer
        className="footer"
        id="footer"
      >
        <Container>
          <Row>
            <Col
              xs={{ span: 12 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
            >
              <Link
                to={`/${HOME}`}
              >
                <img src={logo} alt="Eratek logo" />
              </Link>
            </Col>
          </Row>

          <Row>
            <Col
              xs={{ span: 12 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
            >
              <div className="hr"></div>
            </Col>
          </Row>

          <Row
            className="footer-row"
          >
            <Col
              xs={{ span: 12 }}
              md={{ span: 12 }}
              lg={{ span: 4 }}
            >
              <ColTwo />
            </Col>
            <Col
              xs={{ span: 12 }}
              md={{ span: 12 }}
              lg={{ span: 4 }}
            >
              <InternalLinks />
            </Col>

            <Col
              xs={{ span: 12 }}
              md={{ span: 12 }}
              lg={{ span: 4 }}
            >
              <ColThree />
            </Col>
          </Row>

          <Row>
            <Col
              xs={{ span: 12 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
            >
              <Copyright />
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}
